import { render, staticRenderFns } from "./adddepense.vue?vue&type=template&id=6d604f6c&"
import script from "./adddepense.vue?vue&type=script&lang=js&"
export * from "./adddepense.vue?vue&type=script&lang=js&"
import style0 from "./adddepense.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports